import { useProperty } from '@spotify-internal/remote-config-integration-react';
import { FeatureFlagUsersBool } from '../../../features/src/RemoteConfig';

/** check if current user is an employee */
export function useFeatureFlagsUsers() {
  return useProperty(FeatureFlagUsersBool);
}
